// Export main app
import { App } from './src';

export default App;
